import { BaseService } from '@wiley-flint/framework';
import * as constants from '../../../common/constants';
import Toast from '../../../common/utils/toastUtility';
import { insertDeck } from './APIService/FlashcardAPI';

export default class DeckTitleCreate extends BaseService {
  constructor() {
    super(constants.DECK_TITLE_CREATE_REQUEST, 'deck');
  }

  async handleEvent(_: any, event: any) {
    const { title } = event;
    try {
      const response = await insertDeck(title);
      this.getStore('deck').setTitle(response?.data?.title);
      this.getStore('deck').setDeckId(response?.data?.id);

      if (response?.data) {
        Toast.success('Deck created successfully.');
      } else {
        throw new Error(response);
      }
    } catch (error) {
      Toast.error(`Failed to save Deck title: ${error?.message}`);
    }
  }
}
